import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { PERFECT_PERSONALITY_OPTIONS } from '@/pages/Onboarding/options/Personality/PERFECT_PERSONALITY_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenPersonality: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Personality',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const personality = form.watch('personality');
  const gender = form.watch('gender');

  const getGenderText = () => {
    switch (gender) {
      case 'female':
        return 'she';
      case 'male':
        return 'he';
      default:
        return 'they';
    }
  };

  const handleChange = (
    option: OnbOptionType<LayoutDataType['personality']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        personality: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>
          What kind of vibe does {getGenderText()} give off?
        </OwnAiTitle>
        <OnboardingOptionsList>
          {PERFECT_PERSONALITY_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={personality === option.id}
              control={form.control}
              option={option}
              name="personality"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`personality-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
